export default "__VITE_ASSET__hxAP_qYF__"